(function () {
  'use strict';

  if (window.bbQtyPopupInit) return;
  window.bbQtyPopupInit = true;

  var MAX_QTY = 30;
  var currentTrigger = null;
  var popupEl = null;

  // ── Build popup DOM once ─────────────────────────────────────────
  function createPopup() {
    if (document.getElementById('bb-qty-popup')) {
      popupEl = document.getElementById('bb-qty-popup');
      return;
    }

    var items = '';
    for (var i = 1; i <= MAX_QTY; i++) {
      items += '<div class="bb-qp-item" data-val="' + i + '">' + i + '</div>';
    }

    popupEl = document.createElement('div');
    popupEl.id = 'bb-qty-popup';
    popupEl.setAttribute('hidden', '');
    popupEl.innerHTML =
      '<div class="bb-qp-backdrop"></div>' +
      '<div class="bb-qp-sheet">' +
        '<div class="bb-qp-header">' +
          '<span class="bb-qp-title">Quantity</span>' +
          '<button class="bb-qp-close" type="button" aria-label="Close">&#x2715;</button>' +
        '</div>' +
        '<div class="bb-qp-list">' + items + '</div>' +
        '<div class="bb-qp-footer">' +
          '<input class="bb-qp-input" type="number" placeholder="Enter Qty" min="1" max="' + MAX_QTY + '" inputmode="numeric" />' +
          '<button class="bb-qp-submit" type="button">OK</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(popupEl);

    popupEl.querySelector('.bb-qp-backdrop').addEventListener('click', closePopup);
    popupEl.querySelector('.bb-qp-close').addEventListener('click', closePopup);

    popupEl.querySelector('.bb-qp-list').addEventListener('click', function (e) {
      var item = e.target.closest ? e.target.closest('.bb-qp-item') : null;
      if (!item) return;
      commitQty(parseInt(item.dataset.val, 10));
    });

    popupEl.querySelector('.bb-qp-submit').addEventListener('click', function () {
      var val = parseInt(popupEl.querySelector('.bb-qp-input').value, 10);
      if (val >= 1 && val <= MAX_QTY) commitQty(val);
    });

    popupEl.querySelector('.bb-qp-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var val = parseInt(this.value, 10);
        if (val >= 1 && val <= MAX_QTY) commitQty(val);
      }
    });
  }

  // ── Open ────────────────────────────────────────────────────────
  function openPopup(trigger) {
    currentTrigger = trigger;
    if (!popupEl) return;

    var currentQty = parseInt(trigger.dataset.qty, 10) || 1;

    popupEl.querySelectorAll('.bb-qp-item').forEach(function (item) {
      item.classList.toggle('bb-qp-item--active', parseInt(item.dataset.val, 10) === currentQty);
    });

    popupEl.querySelector('.bb-qp-input').value = '';
    popupEl.removeAttribute('hidden');

    setTimeout(function () {
      var active = popupEl.querySelector('.bb-qp-item--active');
      if (active) active.scrollIntoView({ block: 'center', behavior: 'instant' });
      popupEl.classList.add('bb-qp--open');
    }, 16);
  }

  // ── Close ───────────────────────────────────────────────────────
  function closePopup() {
    if (!popupEl) return;
    popupEl.classList.remove('bb-qp--open');
    var el = popupEl;
    setTimeout(function () { el.setAttribute('hidden', ''); }, 300);
    currentTrigger = null;
  }

  // ── Commit quantity change ───────────────────────────────────────
  function commitQty(qty) {
    if (!currentTrigger) return;
    var lineIndex = parseInt(currentTrigger.dataset.lineIndex, 10);
    var trigger = currentTrigger;
    closePopup();

    if (qty === parseInt(trigger.dataset.qty, 10)) return;

    // Optimistic label update — handles both mobile trigger and desktop pill
    var span = trigger.querySelector('.bb-qty-trigger-val') || trigger.querySelector('.bb-desk-qty-val');
    if (span) span.textContent = qty;
    trigger.dataset.qty = qty;

    document.dispatchEvent(new CustomEvent('quantity-selector:update', {
      bubbles: true,
      detail: { quantity: qty, cartLine: lineIndex }
    }));
  }

  // ── Inject triggers inline with the mobile price row ─────────────
  function injectTriggers() {
    if (window.bbQtyStyle !== 'popup') return;
    if (window.innerWidth >= 750) return;

    document.querySelectorAll('tr.cart-item').forEach(function (row) {
      if (row.querySelector('.bb-qty-trigger')) return;

      var lineIndex = row.getAttribute('data-line');

      // Read qty from the hidden stepper input
      var selector = row.querySelector('quantity-selector-component');
      var input = selector ? selector.querySelector('.quantity__input') : null;
      var qty = input
        ? (parseInt(input.value, 10) || 1)
        : (parseInt(row.getAttribute('data-bb-line-quantity'), 10) || 1);

      // Inject into price wrapper inside the details td (same line as price)
      var detailsTd = row.querySelector('td.cart-item__details');
      var priceWrapper = detailsTd ? detailsTd.querySelector('.cart-item__price-wrapper') : null;
      if (!priceWrapper) return;

      var btn = document.createElement('button');
      btn.className = 'bb-qty-trigger';
      btn.type = 'button';
      btn.dataset.lineIndex = lineIndex;
      btn.dataset.qty = qty;
      btn.innerHTML =
        '<span class="bb-qty-trigger-val">' + qty + '</span>' +
        '<span aria-hidden="true" style="font-size:15px;line-height:1;color:#888;flex-shrink:0;display:inline-block;margin-top:1px">&#9662;</span>';

      btn.addEventListener('click', function () { openPopup(btn); });
      priceWrapper.appendChild(btn);
    });
  }

  // ── Boot ────────────────────────────────────────────────────────
  function init() {
    var isMobile = window.innerWidth < 750;

    if (isMobile && window.bbQtyStyle === 'popup') {
      // Mobile popup mode — inject triggers into price wrappers
      document.body.classList.add('bb-qty-popup-mode');
      createPopup();
      injectTriggers();
    } else if (!isMobile && window.bbDeskQtyStyle === 'shein') {
      // Desktop Shein-pill mode — just create the popup DOM, no triggers
      createPopup();
    }

    // Expose for desktop pill buttons built by bb-cart-desktop.js
    window.bbOpenQtyPopup = openPopup;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:updated', function () {
    setTimeout(injectTriggers, 150);
  });

})();
